import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {

  /** Referência ao header da página para exibir / esconder menus dependendo do display. */
  @ViewChild('header') header: HTMLElement;

  /** Lista de classes CSS do header */
  headerClassList: string[] = ['header'];

  /** Lista de classes CSS do overlay. Adicione classe fade-in para exibir, e fade-out para esconder */
  overlayClassList: string[] = ['overlay', 'has-fade'];

  /** lista de classes CSS do menu mobile. Adicione classe fade-in para exibir, e fade-out para esconder */
  mobileMenuClassList: string[] = ['header__menu', 'has-fade'];

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Alterna entre exibir e esconder o menu na versão mobile do site.
   */
  toggleMenu(event: Event) {
    event.preventDefault();

    if (this.headerClassList.includes('open')) {
      this.headerClassList = ['header'];
      this.mobileMenuClassList = ['header__menu', 'has-fade', 'fade-out'];
      this.overlayClassList = ['overlay', 'has-fade', 'fade-out'];
    }
    else {
      this.headerClassList = ['header', 'open'];
      this.mobileMenuClassList = ['header__menu', 'has-fade', 'fade-in'];
      this.overlayClassList = ['overlay', 'has-fade', 'fade-in'];
    }
  }

}
